// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sz08","textarea":"styles_textarea__2ElzU"};